import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const createKeywordPlanner = createAxiosThunk(
  'bulk/createKeywordPlanner',
  (noArgs, { getState }) => {
    const { filePath, name } = getState().bulk.keywordUploadModal.file
    return api.bulk.postKeywordPlanner({
      filePath,
      name,
    })
  }
)

export const uploadKeywordPlannerFile = createAxiosThunk(
  'bulk/uploadKeywordPlannerFile',
  async file => {
    const {
      data: {
        https: { path },
        property: { filename },
      },
    } = await api.bulk.uploadFile(file)
    return api.response({
      filePath: path,
      name: filename,
    })
  }
)

export const fetchKeywordTemplateFile = createAxiosThunk(
  'bulk/fetchKeywordTemplateFile',
  () => api.bulk.getKeywordTemplateFile()
)

const initialState = {
  isShow: false,
  uploading: false,
  disabled: false,
  file: null,
  templateFileUrl: null,
  templateLoading: false,
}

const keywordUploadModalSlice = createSlice({
  name: 'bulk/keywordUploadModal',
  initialState,

  reducers: {
    showKeywordUploadModal: state => {
      state.isShow = true
    },
    hideKeywordUploadModal: () => initialState,
    clearFile: state => {
      state.file = null
    },
  },

  extraReducers: builder => {
    builder.addCase(uploadKeywordPlannerFile.pending, state => {
      state.uploading = true
    })

    builder.addCase(
      uploadKeywordPlannerFile.fulfilled,
      (state, { payload }) => {
        state.file = payload
        state.uploading = false
      }
    )

    builder.addCase(uploadKeywordPlannerFile.rejected, state => {
      state.uploading = false
    })

    builder.addCase(createKeywordPlanner.pending, state => {
      state.disabled = true
    })

    builder.addCase(createKeywordPlanner.fulfilled, state => {
      state.disabled = false
    })

    builder.addCase(createKeywordPlanner.rejected, state => {
      state.disabled = false
    })

    builder.addCase(fetchKeywordTemplateFile.pending, state => {
      state.templateLoading = true
    })

    builder.addCase(
      fetchKeywordTemplateFile.fulfilled,
      (state, { payload }) => {
        state.templateFileUrl = `${payload.downloadUrl}?download`
        state.templateLoading = false
      }
    )

    builder.addCase(fetchKeywordTemplateFile.rejected, state => {
      state.templateLoading = false
    })
  },
})

const { actions, reducer } = keywordUploadModalSlice
export const { showKeywordUploadModal, hideKeywordUploadModal, clearFile } =
  actions
export default reducer
